import React, { useEffect, useRef, useState } from "react";
// import logo from './logo.svg';
// import './App.css';
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  Link,
  createRoutesFromElements,
  Routes,
  Router,
  createHashRouter,
  useRouteError
} from "react-router-dom";
import Libro from "./components/Libro";
import LibroWrapper from "./components/LibroWrapper";
import ReadingBar from "./components/ReadingBar";
// import libros from "./components/libros";
// import {libros} from "./components/libros";
import OpenAI from "openai";
import { useUser } from "./hooks/useUser";
// import Tour from "./components/utils/Tour";
// import '@tremor/react/dist/lib/colorClassNames';
// import 'intro.js/introjs.css';

// const router =     

function ErrorBoundary() {
  let error = useRouteError();
  console.error(error);
  // Uncaught ReferenceError: path is not defined
  return <div>Dang!</div>;
}

const router = createBrowserRouter(
  // const router = createHashRouter(
  createRoutesFromElements(

    <Route path="/">

      <Route path="libros" element={<p>Debe seleccionar un libro</p>} />

      <Route
        path="libros/:idLibro"
        element={<LibroWrapper></LibroWrapper>}
        errorElement={<ErrorBoundary />}
      />
      <Route
        path="libros/:idLibro/:idCapitulo"
        element={<LibroWrapper></LibroWrapper>}
        errorElement={<ErrorBoundary />}
      />
      <Route
        path="libros/:idLibro/:idCapitulo/:idElementHTML"
        element={<LibroWrapper></LibroWrapper>}
        errorElement={<ErrorBoundary />}
      />

      <Route path="revista" element={<p>Debe seleccionar una revista</p>} />
      <Route
        path="revista/:idRevista"
        element={<LibroWrapper></LibroWrapper>}
      />
      <Route
        path="revista/:idRevista/:idCapitulo"
        element={<LibroWrapper></LibroWrapper>}
        errorElement={<ErrorBoundary />}
      />
      <Route
        path="revista/:idRevista/:idCapitulo/:idElementHTML"
        element={<LibroWrapper></LibroWrapper>}
        errorElement={<ErrorBoundary />}
      />


      <Route path="*" element={<p>Not found</p>} />
    </Route>
  )
);

// export const openai = new OpenAI({ apiKey: process.env.OPENAI_API_KEY });




function App() {
  
  const divRef = useRef<HTMLDivElement>(null);

  const [loading, setLoading] = useState(true);
  const { setUser, user } = useUser();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const keyFromUrl = params.get("key");

    if (keyFromUrl) {
      sessionStorage.setItem("key", keyFromUrl);
    }

    const savedKey = sessionStorage.getItem("key");

    if (savedKey) {
      fetchUser(savedKey);
    } else {
      setLoading(false);
    }
  }, []);

  async function fetchUser(key: string) {
    setLoading(true);
    try {
      const res = await fetch(
        `https://api.virtualpro.co/api/grs_grupo_suscriptor/suscriptor_por_key?key=${key}`,
        { method: "GET", mode: "cors" }
      );
      const data = await res.json();
      if (data && data.length > 0) {
        const suscriptor = data[0];
        setUser(suscriptor);
      }
    } catch (error) {
      console.error("Error fetching suscriptor:", error);
    } finally {
      setLoading(false);
    }
  }
  
  useEffect(() => {
    // console.log(process.env.REACT_APP_OPENAI_API_KEY);
  }, []);

  console.log(user)

  return (
    <div ref={divRef} className="app" >
      {/* CORRECTO */}
      <ReadingBar></ReadingBar>
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
